import Breadcrumbs from "../../components/Common/Breadcrumb"
import React, { useEffect, useState } from "react"
import { Button, Container, Spinner, Table, Tooltip } from "reactstrap"
import { withTranslation } from "react-i18next"
import { get, handleApiError, post, put } from "../../helpers/api_helper"
import Select from "react-select"
import { Link } from "react-router-dom"
import moment from "moment";
import toastr from "toastr"

const Sale = props => {
  const [orders, setOrders] = useState([]);
  const [loading, setLoading] = useState(true);
  const [availableQuantity, setAvailableQuantity] = useState(0);
  const [todayAvailability, setTodayAvailability] = useState(false);
  const [quantityCanBeUpdated, setQuantityCanBeUpdated] = useState(false);
  const [reservedQuantity, setReservedQuantity] = useState(0);
  const [totalItems, setTotalItems] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [nextPage, setNextPage] = useState(null);
  const [prevPage, setPrevPage] = useState(null);
  const [tright, settright] = useState(false);
  const [selectedBag, setSelectedBag] = useState(null);
  const [bags, setBags] = useState([]);
  const [referenceFilter, setReferenceFilter] = useState('');
  const bagIri = '/v1/api/bags/';

  const fetchOrders = async (bag, page) => {
    setLoading(true);
    let params = { page };
    if (bag && 'all' !== bag.value) {
      params.bag = bag.value;
    }
    params['order[createdAt]'] = 'desc';
    const responseOrders = await get('orders', params);
    setLoading(false);
    if (200 === responseOrders.status) {
      const data = responseOrders.data;
      setOrders(data["hydra:member"]);
      setTotalItems(data["hydra:totalItems"]);

      const view = data["hydra:view"];
      setNextPage(view?.["hydra:next"] ? page + 1 : null);
      setPrevPage(view?.["hydra:previous"] ? page - 1 : null);
    }
  };

  const fetchBags = async () => {
    const responseBags = await get('bags');
    if (200 === responseBags.status && responseBags.data['hydra:member'].length > 0) {
      const newBags = responseBags.data['hydra:member'].map(item => ({
        label: item.name,
        value: item.id
      }));
      setBags([{ value: "all", label: "Tous" }, ...newBags]);
    }
  }

  const fetchAvailability = async () => {
    if (!selectedBag || (selectedBag && 'all' === selectedBag.value)) {
      return;
    }

    const responseAvailability = await get(`bags/${selectedBag.value}/check/availability`, {
      today: true
    });

    if (200 === responseAvailability.status) {
      setAvailableQuantity(responseAvailability.data?.availableQuantity);
      setTodayAvailability(responseAvailability.data?.availability);
      setQuantityCanBeUpdated(responseAvailability.data?.quantityCanBeUpdated);
      setReservedQuantity(responseAvailability.data?.reservedQuantity);
    }
  }

  const handleConfirmCollection = async (orderId) => {
    if (window.confirm("Confirmez-vous que ce panier a bien été collecté ?")) {
      try {
        const putResponse = await put(`orders/${orderId}/collect`, { 'collected': true });
        if (200 === putResponse.status) {
          setOrders(orders.map(order =>
            order.id === orderId ? { ...order, ...putResponse.data } : order
          ));
        }
      } catch (error) {
        console.error("Erreur lors de la confirmation :", error);
        alert("Erreur lors de la confirmation.");
      }
    }
  };

  const handleNoShow = async (orderId) => {
    if (window.confirm("Confirmez-vous que le client ne s'est pas présenté à la collecte ?")) {
      try {
        const putResponse = await put(`orders/${orderId}/collect`, { 'collected': false });
        if (200 === putResponse.status) {
          setOrders(orders.map(order =>
            order.id === orderId ? { ...order, ...putResponse.data } : order
          ));
        }
      } catch (error) {
        console.error("Erreur lors de la confirmation :", error);
        alert("Erreur lors de la confirmation.");
      }
    }
  }

  const handleRefreshOrders = () => {
    fetchOrders(selectedBag, 1);
    fetchAvailability();
  }

  const handleFilterByReference = async (e) => {
    setLoading(true);
    e.preventDefault();
    try {
      const referenceParam = referenceFilter.trim().replace(/^#/, "");
      let params = {};
      if (referenceParam) {
        params.reference = referenceParam;
      }
      const responseOrders = await get('orders', params);
      const data = responseOrders.data;
      setOrders(data["hydra:member"]);
      setTotalItems(data["hydra:totalItems"]);
    } catch (error) {
      console.error("Erreur lors du filtrage des commandes :", error);
    } finally {
      setLoading(false);
    }
  };

  const handleUpdateQuantity = async () => {

    if (!selectedBag) {
      return false;
    }

    let dayOfWeek = new Date().getDay();
    dayOfWeek = 0 === dayOfWeek ? 7 : dayOfWeek ;

    try {
      const responseUpdate = await post('bag-availabilities', {
        'bag' : bagIri + selectedBag.value,
        'schedule': [
          {
            'dayOfWeek': dayOfWeek,
            'quantity': availableQuantity
          }
        ],
        'source': 'sales',
      });

      if (201 === responseUpdate.status) {
        toastr.success('Vos modifications ont été enregistrées avec succès.');
        if (availableQuantity < reservedQuantity) {
          fetchOrders(selectedBag, 1);
          fetchAvailability();
        }
      }
    } catch (error) {
      handleApiError(error.response.data);
    }
  }

  const handleSelectBag = (value) => {
    const selected = bags.find(bag => bag.value === value);
    setSelectedBag(selected || null);
  };

  useEffect(() => {
    fetchOrders(selectedBag, currentPage);
  }, [currentPage]);

  useEffect(() => {
    fetchOrders(selectedBag, 1);
  }, [selectedBag]);

  useEffect(() => {
    fetchAvailability();
  }, [selectedBag])

  useEffect(() => {
    fetchBags();
  }, [])

  const uuidToRef = (uuid) => {
    return btoa(uuid).replace(/[^a-zA-Z0-9]/g, '').slice(-8);
  };

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          {/* Render Breadcrumb */}
          <Breadcrumbs
            title={props.t("Ventes")}
            breadcrumbItem={props.t("Ventes")}
          />

          <div className="my-2">
            <div className="p-4 rounded shadow-sm border">
              <p className="text-dark mb-2 fw-bold">
                <strong>Mise à jour en temps réel :</strong> ajustez la{" "}
                <strong>quantité disponible</strong> à tout moment. Si elle devient inférieure
                au nombre de réservations, certaines commandes seront automatiquement annulées,
                en priorité celles avec un <strong>paiement en espèces</strong>.{" "}
                Pour garantir une <strong>répartition équitable</strong>, certaines commandes
                pourront également être <strong>modifiées partiellement</strong>, afin de ne pas
                pénaliser d'autres clients déjà engagés.{" "}
                <span className="text-info">
                  Modification possible jusqu'à <strong>1 heure avant l'ouverture de la collecte</strong>.
                </span>
              </p>

              <p className="text-dark mb-2">
                <i className="mdi mdi-information-outline me-1 font-size-16"></i>
                Les lignes en <span className="p-2 bg-warning bg-opacity-10 rounded">jaune clair</span> correspondent aux commandes à collecter <strong>aujourd’hui</strong>.
              </p>
              <p className="text-dark mb-0">
                <i className="mdi mdi-information-outline me-1 font-size-16"></i>
                Les lignes en <span className="p-2 bg-success bg-opacity-10 rounded">vert clair</span> correspondent aux commandes déjà collectées <strong>aujourd’hui</strong>.
              </p>
            </div>

            <div className="d-flex justify-content-end align-items-center my-4">
              <span className="text-info mx-3 fw-bold">Sélectionner un Panier</span>
              <select
                value={selectedBag?.value || ''}
                onChange={e => handleSelectBag(e.target.value)}
                className="form-select w-75"
              >
                <option value="">-- Choisir un panier --</option>
                {bags.map(bag => (
                  <option key={bag.value} value={bag.value}>
                    {bag.label}
                  </option>
                ))}
              </select>
            </div>

            {selectedBag && "all" !== selectedBag.value && (
              <div className="mb-4">
                <h5 className="fw-bold mb-2 text-center font-size-14">
                  Gérer la quantité pour aujourd'hui
                </h5>
                {todayAvailability ? (
                  <div className="d-flex justify-content-center align-items-center gap-3 flex-wrap">
                    {/* Input Group */}
                    <div className="input-group w-auto">
                      <button
                        className="btn btn-outline-primary fw-bold z-0"
                        type="button"
                        disabled={
                          reservedQuantity >= availableQuantity
                          && !quantityCanBeUpdated
                        }
                        onClick={() =>
                          setAvailableQuantity(
                            availableQuantity > 0 ? availableQuantity - 1 : 0
                          )
                        }
                      >
                        −
                      </button>
                      <input
                        type="text"
                        className="form-control text-center"
                        style={{ width: "70px" }}
                        value={availableQuantity}
                        disabled={
                          reservedQuantity >= availableQuantity
                          && !quantityCanBeUpdated
                        }
                        onChange={e =>
                          setAvailableQuantity(
                            Number(e.target.value) > 0
                              ? Number(e.target.value)
                              : 0
                          )
                        }
                      />
                      <button
                        className="btn btn-outline-primary fw-bold z-0"
                        type="button"
                        onClick={() =>
                          setAvailableQuantity(availableQuantity + 1)
                        }
                      >
                        +
                      </button>
                    </div>
                    <div className="d-flex align-items-center">
                      <span>
                        Paniers disponibles aujourd'hui :
                        <strong className="mx-1 font-size-16">
                          {availableQuantity}
                        </strong>
                        {reservedQuantity > 0 && (
                          <small className="text-info font-size-13">
                            (dont{" "}
                            <strong className="font-size-16">
                              {reservedQuantity}
                            </strong>{" "}
                            déjà réservé
                            {reservedQuantity > 1 ? "s" : ""})
                          </small>
                        )}
                      </span>
                    </div>
                    {!(
                      availableQuantity < reservedQuantity &&
                      !quantityCanBeUpdated
                    ) ? (
                      <Button
                        color="success"
                        size="sm"
                        onClick={handleUpdateQuantity}
                      >
                        Mettre à jour
                      </Button>
                    ) : (
                      <></>
                    )}
                  </div>
                ) : (
                  <div className="text-center">
                    <h5 className="font-size-13 text-info">
                      vous n'avez définit aucune quantité pour aujourdh'ui
                    </h5>
                  </div>
                )}
              </div>
            )}

            <div className="mb-3">
              <div className="mb-3 d-flex justify-content-end">
                <input
                  type="text"
                  className="form-control me-2 w-25"
                  placeholder="Filtrer par référence"
                  value={referenceFilter}
                  onChange={e => setReferenceFilter(e.target.value)}
                />
                <Button
                  color="primary"
                  className="btn btn-primary"
                  onClick={() => handleFilterByReference(event)}
                >
                  Filtrer
                </Button>
              </div>
              <h5 className="fw-bold">
                Liste des commandes ({totalItems}){" "}
                <Link to={"#"} onClick={handleRefreshOrders}>
                  <i className="mdi mdi-refresh font-size-18" />
                </Link>
              </h5>
              {loading ? (
                <div className="text-center">
                  <Spinner animation="border" variant="primary" />
                  <p>Chargement des commandes...</p>
                </div>
              ) : (
                <Table bordered responsive>
                  <thead>
                    <tr>
                      <th>Référence</th>
                      <th>Quantité</th>
                      <th>Prix</th>
                      <th>Nom du Panier</th>
                      <th>Statut</th>
                      <th>Date de commande</th>
                      <th>Code de collecte</th>
                      <th>Mode de paiement</th>
                      <th>Actions</th>
                    </tr>
                  </thead>
                  <tbody>
                    {orders.length > 0 ? (
                      orders.map(order => {
                        const bgClass = moment(
                          order.startCollectionDate
                        ).isSame(moment(), "day") && 'created' === order.status.code
                          ? "bg-warning bg-opacity-10"
                          : (  moment(
                            order.startCollectionDate
                          ).isSame(moment(), "day") && 'collected' === order.status.code ? "bg-success bg-opacity-10" : "")

                        return (
                          <tr key={order.id}>
                            <td className={bgClass}>{"#" + order.reference}</td>
                            <td className={bgClass}>{order.quantity}</td>
                            <td className={bgClass}>{order.price} Dhs</td>
                            <td className={bgClass}>{order.bag.name}</td>
                            <td className={bgClass}>
                              <span
                                className={`badge font-size-11 ${
                                  order.status.code === "created"
                                    ? "bg-info"
                                    : order.status.code === "collected"
                                    ? "bg-primary"
                                    : order.status.code === "canceled"
                                    ? "bg-warning"
                                    : order.status.code === "missed"
                                    ? "bg-warning"
                                    : "bg-dark"
                                }`}
                              >
                                {order.status.name}
                              </span>
                            </td>
                            <td className={bgClass}>
                              {new Date(order.createdAt).toLocaleString(
                                "fr-FR",
                                {
                                  day: "2-digit",
                                  month: "2-digit",
                                  year: "numeric",
                                  hour: "2-digit",
                                  minute: "2-digit",
                                }
                              )}
                            </td>
                            <td className={bgClass}>{order.collectCode}</td>
                            <td className={bgClass}>
                              {order.paymentMethod === 1
                                ? "Payé en espèces"
                                : "Payé par CB"}
                            </td>
                            <td className={`text-center ${bgClass}`}>
                              {order.paymentMethod === 1 && order.status.code === "created" && (
                                <div className="d-flex flex-column flex-sm-row justify-content-center align-items-center gap-2">
                                  <Button
                                    color="success"
                                    size="sm"
                                    onClick={() => handleConfirmCollection(order.id)}
                                  >
                                    <i className="bx bx-check-circle me-1"></i>
                                    Confirmer la collecte
                                  </Button>
                                  <Button
                                    color="danger"
                                    size="sm"
                                    onClick={() => handleNoShow(order.id)}
                                  >
                                    <i className="bx bx-user-x me-1"></i>
                                    Le client ne s’est pas présenté
                                  </Button>
                                </div>
                              )}
                            </td>
                          </tr>
                        )
                      })
                    ) : (
                      <tr>
                        <td colSpan="8" className="text-center">
                          Aucune commande disponible.
                        </td>
                      </tr>
                    )}
                  </tbody>
                </Table>
              )}
            </div>

            <div className="d-flex justify-content-center my-3">
              <Button
                className="btn btn-sm mx-2"
                color="outline-primary"
                disabled={!prevPage}
                onClick={() => setCurrentPage(prevPage)}
              >
                ← Précédent
              </Button>
              <Button
                className="btn btn-sm"
                color="outline-primary"
                disabled={!nextPage}
                onClick={() => setCurrentPage(nextPage)}
              >
                Suivant →
              </Button>
            </div>
          </div>
        </Container>
      </div>
    </React.Fragment>
  )
}

export default withTranslation()(Sale);
